var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"macaoPage",staticStyle:{"margin-top":"220px"}},[_c('div',{staticClass:"a_jc",domProps:{"innerHTML":_vm._s(_vm.aomenList.content)}}),_vm._v(" "),_c('Nav',{attrs:{"titles":_vm.titles,"titleChild":_vm.titleChild,"navState":_vm.navState,"tipsState":_vm.tipsState}})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-c8d8199e","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/MacaoPage.vue
// module id = null
// module chunks = 